import React, {Component} from 'react';
import {forceCheck} from 'react-lazyload';
import {Button, Col, FormControl, FormGroup, OverlayTrigger, Popover, Row} from 'react-bootstrap';
import Select from 'react-select';
import {toastr} from 'react-redux-toastr';
import {connect} from 'react-redux';
import {Redirect, Route, Switch, withRouter} from 'react-router-dom';
import {
    copy_into_saved_design,
    create_blank_design,
    delete_design,
    fetch_design_categories,
    fetch_owned_designs,
} from './actions'

import {open_login_modal} from '../../actions';
import {fetch_folders} from '../Folders/actions';
import "./style.css";

import DashboardSidebar from '../../components/dashboardSidebar';
// import NewDashboardHome from '../../components/Dashboard_Home';
import ShareLinkModal from '../../components/ShareLinkModal';
import BrandKit from '../BrandKit';
import DesignOrders from '../DesignOrders';
import Categories from '../Categories';
import SharedDesigns from '../SharedDesigns';
import Folders from '../Folders';
import DesignsPanel from '../../components/DesignsPanel';
import Wizard from '../../views/Wizard';
import Mobile_Deterrent from '../../views/MobileDeterrent';
import Designmaker_Navbar from '../../components/Designmaker_Navbar';
import 'react-bootstrap-typeahead/css/Typeahead.css';

import ContextMenu from '../../components/contextMenu';
import SearchContainer from "./searchContainer";
import TemplateSearch from "../../components/TemplateSearch";
import ImageBox from "../../components/ImageBox";
import PenguinSlider from "../../components/PenguinSlider";
import {MoveToFolderModal} from "../Folders/commons/MoveToFolderModal";
import {DeleteDesignModal} from "../Folders/commons/DeleteDesignModal";
import Skeleton from 'react-loading-skeleton';
import {ClientNames, Header, ThemeConfig} from "@designs-ai/react";
import {loginHandler} from "../../utils/loginUtils";

const styles = {
    brand: {
        paddingLeft: 31,
        color: '#FF841F',
        fontSize: 26,
        fontWeight: '800',
        fontFamily: "Montserrat",
    },
    navbar: {
        boxShadow: "0 2px 16px 0 rgba(177,177,177,0.5)",
        color: "white",
        fontFamily: 'Montserrat',
        position: 'fixed',
        width: '100%',
        zIndex: 120
    },
    brand_subscript: {
        color: "#333333",
        fontSize: 14,
        float: 'right'
    },
    profile_button: {
        backgroundColor: 'white',
        color: '#333333',
        fontSize: 14,
        backgroundImage: 'none',
        border: 'none',
        textShadown: 'none',
        boxShadow: 'none',
    },
    navbar_item: {
        marginTop: 6
    }
}


const Categories_Panel = ({ design_template_on_click, ThumbnailContextMenu, unflattened_categories, page, redirect_page }) => {
    try {
        return (
            <React.Fragment>
                {unflattened_categories.map((category, index) => (
                    <div key={"category-panel-div-"+index}>
                        <Row style={{ marginTop: 25, marginBottom: 15}}>
                            <span style={{fontFamily: 'Montserrat', fontWeight: 800, fontSize: 22}}>{category.name}</span>
                        </Row>
                        <Row style={{'marginTop': '10px', marginBottom: 10}}>
                            <div style={{'paddingLeft': '5px', 'paddingRight': '5px'}}>
                                <PenguinSlider id={"category-slider-" + category._id} height={220}>
                                    {category.children && category.children.map((element, idx) => (
                                        <>
                                            <a style={{ visibility: 'hidden' }} href={element.example?(global.config.website_url + 'designmaker/start/template/' + (element.example.custom_url||element.example._id)):''} />
                                            <ImageBox
                                                key={'category-' + element._id}
                                                idx={idx}
                                                image_src={global.config.static_file_server_path + element.example.thumbnail}
                                                name={element.name}
                                                disable_overlay={true}
                                                image_style={{
                                                    maxWidth: 160,
                                                    maxHeight: 185,
                                                    height: 'unset',
                                                    marginLeft: 'auto',
                                                    marginRight: 'auto',
                                                    objectFit: 'contain',
                                                    display: 'block',
                                                    boxShadow: '0 0 8px 0 rgba(66,66,66,0.5)'
                                                }}
                                                container_style={{width: 165}}
                                                footer_text={element.name}
                                                context_menu={<ThumbnailContextMenu design={element.example} template preview_page={page=="templates" ? true : false} />}
                                                on_click={page != "templates" ? () => {
                                                        design_template_on_click(element.example, element)
                                                    } : () => {
                                                        redirect_page('/designmaker/start/template/' + (element.example.custom_url||element.example._id));
                                                    }
                                                }
                                                skeleton={true}
                                                skeleton_width={160 * (element.dimensions.width > element.dimensions.height ? 1 : (element.dimensions.width/element.dimensions.height))}
                                                skeleton_height={185 * (element.dimensions.height > element.dimensions.width ? 1 : (element.dimensions.height/element.dimensions.width))}
                                            />
                                        </>
                                    ))}
                                </PenguinSlider>
                            </div>
                        </Row>
                    </div>
                ))}
            </React.Fragment>
        )
    } catch(err) {
        console.log('error in category panel --> ', err);
        return ''
    }
};


class Dashboard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            template_categories: [],
            unflattened_categories: [],
            templates: [],
            saved_designs: [],
            custom_height: '',
            custom_width: '',
            custom_dimension_units: 'px',
            dimension_invalid_message: '',
            redirect: false,
            redirect_url: null,
            apply_brand_kit: false,
            active_page: this.props.match.url.split('/')[1],
            folders: [],
            display_move_to_folder_modal: false,
            display_delete_design_modal: false,
            active_design: null,
            active_saved_design_id: null,
            saved_design_share_modal: false,
            active_custom_url: null,
            device_type: 'desktop',
            show_share_modal: false,
        }
    }

    update_window_size = () => {
        if (window.innerWidth > 767) {
            this.setState({ device_type: 'desktop'});
        } else {
            this.setState({ device_type: 'tablet'});
        }
    }

    redirect_page = (url) => {
        this.setState({redirect_url: url, redirect: true})
    };


    update_custom_width = (value) => {
        this.set_state({
            custom_width: value
        })
    };

    update_custom_height = (value) => {
        this.set_state({
            custom_height: value
        })
    };

    convert_to_px = (w, h, units) => {
        var r
        if (units === 'mm') {
            r = {
                w: (w * 3.78),
                h: h * 3.78,
            }
        } else if (units === 'cm') {
            r = {
                w: w * 37.8,
                h: h * 37.8,
            }
        } else if (units === 'in') {
            r = {
                w: w * 96,
                h: h * 96,
            }
        }

        if (r.w.toString().length > 5) {
            r.w = Number(r.w.toFixed(3))
        }

        if (r.h.toString().length > 5) {
            r.h = Number(r.h.toFixed(3))
        }

        return r
    };

    convert_to_units = (w, h, units) => {
        var r
        if (units === 'mm') {
            r = {
                w: w / 3.78,
                h: h / 3.78,
            }
        } else if (units === 'cm') {
            r = {
                w: w / 37.8,
                h: h / 37.8,
            }
        } else if (units === 'in') {
            r = {
                w: w / 96,
                h: h / 96,
            }
        }

        if (r.w.toString().length > 5) {
            r.w = Number(r.w.toFixed(3))
        }

        if (r.h.toString().length > 5) {
            r.h = Number(r.h.toFixed(3))
        }

        return r
    };

    update_custom_dimension_units = (value) => {
        var current_units = this.state.custom_dimension_units
        var new_width = 0;
        var new_height = 0;
        var result
        if (current_units === 'px') {
            result = this.convert_to_units(this.state.custom_width, this.state.custom_height, value);
            new_width = result.w;
            new_height = result.h;
        } else {
            var px_result = this.convert_to_px(this.state.custom_width, this.state.custom_height, current_units);
            if (value === 'px') {
                new_width = px_result.w;
                new_height = px_result.h;
            } else {
                result = this.convert_to_units(px_result.w, px_result.h, value);
                new_width = result.w;
                new_height = result.h;
            }
        }

        this.set_state({
            custom_dimension_units: value,
            custom_width: new_width,
            custom_height: new_height,
        }).then(() => {
            this.validate_and_update_custom_dimensions()
        })
    };

    validate_and_update_custom_dimensions = () => {
        var r = this.validate_custom_dimensions();
        if (!r.test && r.message !== this.state.dimension_invalid_message) {
            this.setState({dimension_invalid_message: r.message})
        } else if (this.state.dimension_invalid_message !== '') {
            this.setState({dimension_invalid_message: ''})
        }
    };

    validate_custom_dimensions = () => {
        var width = Number(this.state.custom_width);
        var height = Number(this.state.custom_height);
        var units = this.state.custom_dimension_units;

        /*
            1mm = 3.8px
            1in = 96px
            1cm = 38px
        */

        if (isNaN(width)) {
            return {
                test: false,
                message: 'Invalid width'
            }
        }

        if (isNaN(height)) {
            return {
                test: false,
                message: 'Invalid height'
            }
        }


        if (units === 'px' && ((width < 40 || width > 8000) || (height < 40 || height > 8000))) {
            return {
                test: false,
                message: 'Dimensions must be greater than 40px and smaller than 8000px'
            }
        } else if (units === 'mm' && ((width < 10.583 || width > 2116.664) || (height < 10.583 || height > 2116.664))) {
            return {
                test: false,
                message: 'Dimensions must be greater than 10.583mm and smaller than 2116.664mm'
            }
        } else if (units === 'cm' && ((width < 1.058 || width > 211.664) || (height < 1.058 || height > 211.664))) {
            return {
                test: false,
                message: 'Dimensions must be greater than 1.058cm and smaller than 211.664cm'
            }
        } else if (units === 'in' && ((width < 0.417 || width > 83.328) || (height < 0.417 || height > 83.328))) {
            return {
                test: false,
                message: 'Dimensions must be greater than 0.417in and smaller than 83.328in'
            }
        }


        return {
            test: true,
            message: 'dimensions are valid'
        }
    }

    set_state = async state => new Promise(resolve => this.setState(state, resolve));

    componentDidMount() {
        this.fetch_user_resources();
        // this.fetch_teams();
        this.fetch_design_categories();
        this.update_window_size();
        window.onresize = this.update_window_size;
        window.onscroll = e => forceCheck()
    }

    componentDidUpdate(prev_props, prev_state) {
        if (this.state.redirect !== prev_state.redirect) {
            this.setState({redirect: false, redirect_url: null})
        }
        if (prev_props.user != this.props.user) {
            this.fetch_user_resources();
        }
    }


    fetch_user_resources = () => {
        var fetch_arr = []
        // fetch_arr.push(this.props.fetch_design_templates())
        if (this.props.user) {
            fetch_arr.push(this.props.fetch_owned_designs())
        } else {
            fetch_arr.push(Promise.resolve([]))
        }

        Promise.all(fetch_arr).then(([/*templates, */saved_designs]) => {
            this.setState({/*templates, */saved_designs})
        })
    };

    fetch_design_categories = async () => {
        try {
            var url = global.config.server_path + 'category/fetch_all_design_categories';
            var resp = await fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({})});
            resp = await resp.json();
            var all_cats = resp.data.sort((a, b) => (a.priority < b.priority ? 1 : -1));
            all_cats = all_cats.map(cat => {
                var flag = false;
                if (cat.children) {
                    cat.children = cat.children.sort((a, b) => (a.priority <= b.priority ? 1 : -1));
                    if (cat.children.length) {
                        flag = true;
                    }
                } 

                if (!flag) {
                    return null;
                } else {
                    return cat;
                }
            });
            all_cats = all_cats.filter(x => x);

            var flattened_cats = all_cats.reduce((final,elem) => final.concat(elem.children),[])
            flattened_cats = flattened_cats.sort((a, b) => (a.priority <= b.priority ? 1 : -1));
            this.setState({
                template_categories: flattened_cats,
                unflattened_categories: all_cats
            });
        } catch(err) {
            console.log(err);
        }
    }

    logout = () => {
        this.props.logout();
        toastr.success('You have been Logged Out')
    }

    design_template_on_click = (template, category) => {
        // var apply_brand_kit = (template.apply_brand_kit?'?abk='+encodeURIComponent(1):'');
        let category_name = (category&&category._id) ? '?category=' + encodeURIComponent(category._id) : ((template.categories && template.categories.length) ? '?category=' + encodeURIComponent(template.categories[0]) : '');

        this.props.copy_into_saved_design(template._id)
            .then(copied_design => {
                this.redirect_page('/designmaker/start/designs/' + copied_design._id + '/edit' + category_name)
            })
            .catch(err => Promise.reject(err))
    }

    saved_design_on_click = (saved_design) => {
        this.redirect_page('/designmaker/start/designs/' + saved_design._id + '/edit')
    }

    create_custom_dimension_design = () => {
        var validate = this.validate_custom_dimensions()
        if (!validate.test) {
            if (!validate.test) {
                this.setState({dimension_invalid_message: validate.message})
                return
            }
        }

        this.props.create_blank_design(this.state.custom_width, this.state.custom_height, this.state.custom_dimension_units)
            .then(copied_design => {
                this.redirect_page('/designmaker/start/designs/' + copied_design._id + '/edit');
            })
            .catch(err => Promise.reject(err))
    }

    toggle_overlay = () => {
        if (window.document.getElementById('popover_overlay').style.display === "none") {
            window.document.getElementById('popover_overlay').style.display = "block"
        } else {
            window.document.getElementById('popover_overlay').style.display = "none"
        }
    }

    show_move_to_folder_modal = (design_id) => {
        fetch_folders()
            .then(data => data.json())
            .then(data => this.setState({folders: data.data}))
            .catch(err => {
                console.error((err));
                toastr.error("Something went wrong");
            });

        this.setState({
            display_move_to_folder_modal: true,
            active_design: design_id
        })
    };

    show_delete_design_modal = (design_id) => {
        this.setState({
            display_delete_design_modal: true,
            active_design: design_id
        })
    };

    activate_share_modal = ({ custom_url, design_id, is_saved_design }) => {
        if (is_saved_design) {
            this.setState({
                show_share_modal: true,
                active_design: null,
                active_custom_url: null,
                active_saved_design_id: design_id,
                saved_design_share_modal: true,
            })
        } else {
            this.setState({
                show_share_modal: true,
                active_design: design_id,
                active_custom_url: custom_url,
                active_saved_design_id: null,
                saved_design_share_modal: false,
            })
        }
    };

    delete_saved_design = () => {
        delete_design(this.state.active_design)
            .then(() => this.setState({display_delete_design_modal: false, active_design: null}))
            .then(() => this.props.fetch_owned_designs())
            .then(data => this.setState({saved_designs: data}))
            .catch(err => toastr.error("Something went wrong :/"))
    };


    refreshDesignsData = () => {
        this.props.fetch_owned_designs()
            .then(data => this.setState({saved_designs: data}))
            .catch(err => toastr.error("Something went wrong :/"))
    };

    copySavedDesignOnClick = async (design) => {
        fetch(global.config.server_path+'saved_design/clone_saved_design/', {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({saved_design_id: design._id, name_append: ' Copy'})})
            .then(resp => resp.json()).then(resp => resp.data)
            .then(data => {
                this.refreshDesignsData();
                window.open(global.config.website_url + 'designmaker/start/designs/' + data._id +'/edit', '_blank');
            })
    }

    ThumbnailContextMenu = ({ design, template, preview_page }) => {
        let designs_context_menu = preview_page ? [{
                name: 'Share',
                action: e => {
                    e.stopPropagation();
                    this.activate_share_modal({ design_id: design._id, custom_url: design.custom_url });
                }
            }, {
                name: 'Use this template',
                action: e => {
                    e.stopPropagation();
                    this.design_template_on_click(design);
                }
            }] : (template ? [{
                name: 'Share',
                action: e => {
                    e.stopPropagation();
                    this.activate_share_modal({ design_id: design._id, custom_url: design.custom_url });
                }
            }, {
                name: 'Preview',
                action: e => {
                    this.redirect_page('/designmaker/start/template/' + (design.custom_url||design._id));
                }
            }] : [{
                name: 'Make a copy',
                action: e => {
                    e.stopPropagation();
                    this.copySavedDesignOnClick(design);
                }
            },{
                name: 'Move to Folder',
                action: e => {
                    e.stopPropagation();
                    this.show_move_to_folder_modal(design._id);
                }
            },{
                name: 'Share',
                action: e => {
                    e.stopPropagation();
                    this.activate_share_modal({ design_id: design._id, is_saved_design: true });
                }
            }, {
                name: 'Delete',
                action: e => {
                    e.stopPropagation();
                    this.show_delete_design_modal(design._id);
                }
            }]
        );

        return (
            <>  
                <ContextMenu 
                    share_link={true} 
                    template_id={design._id} 
                    contextMenuName="your-designs-context-menu" 
                    contextMenuOptions={designs_context_menu}
                />
            </>
        );
    };

    inmagine_login = () => {
        window.localStorage.setItem('last_url', window.location.href);
        window.location.href = global.config.designs_ai_server_path + "user/sign-in?c="+global.config.dm_client_id+"&r=" + global.config.auth_redirect_path_dm;
    };

    inmagine_logout = () => {
        window.localStorage.setItem('last_url', window.location.href);
        fetch(global.config.server_path+'user/logout', {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include'})
            .then(res => {
                window.location.href = global.config.designs_ai_server_path + "user/sign-out?c="+global.config.dm_client_id+"&r=" + global.config.auth_redirect_path_dm;
            })
            .catch(err => {
                console.error(err);
                window.location.href = global.config.designs_ai_server_path + "user/sign-out?c="+global.config.dm_client_id+"&r=" + global.config.auth_redirect_path_dm;
            })
    };

    DashboardHome = ({ page }) => (
        <div id="dashboard_home" style={{paddingTop: 30, paddingRight: '30px', 'paddingLeft': '5px'}}>

            <MoveToFolderModal show={this.state.display_move_to_folder_modal} onHide={() => this.setState({display_move_to_folder_modal: false, active_design: null})} folders={this.state.folders} omitFolders={this.props.user?[this.props.user.my_designs_folder]:[]} activeDesign={this.state.active_design}/>
            <DeleteDesignModal show={this.state.display_delete_design_modal} onHide={() => this.setState({display_delete_design_modal: false, active_design: null})} deleteOnClick={this.delete_saved_design}/>

            <SearchContainer categories={this.state.template_categories} redirectPage={this.redirect_page}/>

            <Row style={{'fontWeight': 'bold', 'marginTop': '25px', 'marginBottom': '20px'}}>
                <span style={{fontFamily: 'Montserrat', fontWeight: 800, fontSize: 22}}>Popular Categories
                    {page != "templates" && (
                        <OverlayTrigger 
                            trigger="click" 
                            placement="bottom" 
                            overlay={
                                <Popover {...this.props} id="custom_dimension_box" className='popover_left'>
                                    <this.CustomDimensionBox/>
                                </Popover>
                            }
                        >
                            <Button id="overlay_button" className="popover-button-custom" style={{'float': 'right'}} onClick={this.toggle_overlay}>Custom Dimensions</Button>
                        </OverlayTrigger>
                    )}
                    {/* <Button className="popover-button-custom" style={{'float': 'right', paddingLeft: 10}} */}
                    {/*         onClick={() => this.redirect_page('/designmaker/start/categories')}>View All</Button> */}
                </span>
            </Row>

            <Row style={{'marginTop': '10px', marginBottom: 10}}>
                <div style={{'paddingLeft': '5px', 'paddingRight': '5px'}}>
                    <PenguinSlider id="design-templates-dashboard-slider" height={220}>
                        {this.state.template_categories && this.state.template_categories.length>0 ?(this.state.template_categories.map((element, idx) => (
                            <>
                                <a style={{ visibility: 'hidden' }} href={global.config.website_url + 'designmaker/start/template/' + (element.example.custom_url||element.example._id)} />
                                <ImageBox
                                    key={'design-templates-dashboard' + idx}
                                    idx={idx}
                                    image_src={global.config.static_file_server_path + element.example.thumbnail}
                                    name={element.name}
                                    disable_overlay={true}
                                    image_style={{
                                        maxWidth: 160,
                                        maxHeight: 185,
                                        height: 'unset',
                                        marginLeft: 'auto',
                                        marginRight: 'auto',
                                        objectFit: 'contain',
                                        display: 'block',
                                        boxShadow: '0 0 8px 0 rgba(66,66,66,0.5)'
                                    }}
                                    container_style={{width: 165}}
                                    context_menu={
                                        <this.ThumbnailContextMenu 
                                            design={element.example} 
                                            template={true}
                                            preview_page={page=="templates" ? true : false} 
                                        />
                                    }
                                    footer_text={element.name}
                                    on_click={page != "templates" ? () => {
                                            this.design_template_on_click(element.example, element)
                                        } : () => {
                                            this.redirect_page('/designmaker/start/template/' + (element.example.custom_url||element.example._id));
                                        }
                                    }
                                    skeleton={true}
                                    skeleton_width={160 * (element.dimensions.width > element.dimensions.height ? 1 : (element.dimensions.width/element.dimensions.height))}
                                    skeleton_height={185 * (element.dimensions.height > element.dimensions.width ? 1 : (element.dimensions.height/element.dimensions.width))}
                                />
                            </>
                        ))):([...new Array(20)].map((elem,idx) => (
                            <ImageBox
                                key={'design-templates-dashboard' + idx}
                                idx={idx}
                                disable_overlay={true}
                                image_style={{
                                    maxWidth: 160,
                                    maxHeight: 185,
                                    height: 'unset',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                    objectFit: 'contain',
                                    display: 'block',
                                    boxShadow: '0 0 8px 0 rgba(66,66,66,0.5)'
                                }}
                                text_loader={true}
                                skeleton={true}
                                skeleton_width={160}
                                skeleton_height={185}
                            />
                            // <Skeleton 
                            //     height={160}
                            //     width={185}
                            // />
                        ))) }
                    </PenguinSlider>
                </div>
            </Row>

            {(page!='templates') &&this.props.user && this.state.saved_designs.length > 0 && (
                <div>
                    <Row>
                        <span style={{fontFamily: 'Montserrat', fontWeight: 800, fontSize: 22}}>Your designs</span>
                        <Button className="popover-button-custom" style={{'float': 'right', paddingLeft: 10}}
                                onClick={() => this.redirect_page('/designmaker/start/all-designs')}>View All</Button>
                    </Row>
                    <Row style={{'marginTop': '10px', marginBottom: 10}}>
                        <div style={{'paddingLeft': '5px', 'paddingRight': '5px'}}>
                            <PenguinSlider id="saved-designs-dashboard-slider" height={220}>
                                {this.state.saved_designs.map((design, idx) => (
                                    <ImageBox
                                        key={'saved-designs-dashboard' + idx}
                                        idx={idx}
                                        image_src={global.config.static_file_server_path + design.thumbnail + '?t='+Date.now()}
                                        name={design.name}
                                        disable_overlay={true}
                                        image_style={{
                                            maxWidth: 148,
                                            maxHeight: 173,
                                            height: 'unset',
                                            marginLeft: 'auto',
                                            marginRight: 'auto',
                                            objectFit: 'contain',
                                            display: 'block',
                                            boxShadow: '0 0 8px 0 rgba(66,66,66,0.5)'
                                        }}
                                        container_style={{width: 165}}
                                        footer_text={design.name}
                                        context_menu={<this.ThumbnailContextMenu design={design}/>}
                                        on_click={() => this.saved_design_on_click(design)}
                                        skeleton={true}
                                        skeleton_width={160}
                                        skeleton_height={185}
                                        boxed_view={true}
                                        max_container_height={185}
                                    />
                                ))}
                            </PenguinSlider>
                        </div>
                    </Row>
                </div>
            )}


            <Categories_Panel 
                unflattened_categories={this.state.unflattened_categories}
                design_template_on_click={this.design_template_on_click}
                ThumbnailContextMenu = {this.ThumbnailContextMenu}
                page={page}
                redirect_page={this.redirect_page}
            />

        </div>
    );

    CustomDimensionBox = () => (
        <div>
            <Row>
                <Col xs={4} style={{'paddingLeft': '5px', 'paddingRight': '3px'}}>
                    <FormControl
                        style={{height: '38px', 'width': '100%'}}
                        type="text"
                        value={this.state.custom_width}
                        onChange={(e) => {
                            this.update_custom_width(e.target.value)
                        }}
                        onBlur={this.validate_and_update_custom_dimensions}
                        placeholder="width"
                    />
                </Col>
                <Col xs={4} style={{'paddingLeft': '5px', 'paddingRight': '3px'}}>
                    <FormControl
                        style={{height: '38px', 'width': '100%'}}
                        type="text"
                        value={this.state.custom_height}
                        onChange={(e) => {
                            this.update_custom_height(e.target.value)
                        }}
                        onBlur={this.validate_and_update_custom_dimensions}
                        placeholder="height"
                    />
                </Col>
                <Col xs={4} style={{'paddingLeft': '5px', 'paddingRight': '3px'}}>
                    <Select
                        style={{height: '38px', 'width': '100%'}}
                        styles={{
                            option: (provided, state) => ({
                                ...provided,
                                textAlign: 'left',
                                backgroundColor: state.isSelected ? '#C8CDD4' : (state.isFocused ? '#F1F2F3' : 'white'),
                            })
                        }}
                        value={{
                            label: this.state.custom_dimension_units,
                            value: this.state.custom_dimension_units
                        }}
                        options={[{label: 'px', value: 'px'}, {label: 'in', value: 'in'}, {
                            label: 'mm',
                            value: 'mm'
                        }, {label: 'cm', value: 'cm'}]}
                        onChange={(selection) => {
                            this.update_custom_dimension_units(selection.value)
                        }}
                    />
                </Col>
            </Row>
            <Row style={{'paddingLeft': '5px', 'paddingRight': '3px'}}>
                <label style={{fontWeight: '200', color: 'red'}}>{this.state.dimension_invalid_message}</label>
            </Row>
            <FormGroup>
            </FormGroup>
            <Button type="button" onClick={this.create_custom_dimension_design}
                    className="popover-button-custom create-new-design" style={{'width': '100%'}} type="submit">Create
                New Design</Button>
        </div>
    );

    render() {

        let {redirect, redirect_url} = this.state;

        if (redirect) {
            return (<Redirect push to={redirect_url}/>)
        }

        

        if (this.state.device_type === "tablet") {
            return (<Mobile_Deterrent/>);
        }

        return (
            <div>
                <div id="popover_overlay" style={{
                    top: 0,
                    left: 0,
                    position: "fixed",
                    zIndex: "1000",
                    height: "100%",
                    width: "100%",
                    display: "none"
                }} onClick={() => document.getElementById('overlay_button').click()}/>
                <ShareLinkModal 
                    show_share_modal={this.state.show_share_modal}
                    hide_share_modal={() => this.setState({ show_share_modal: false, active_design: null, active_custom_url: null })}
                    template_id={this.state.active_design}
                    custom_url={this.state.active_custom_url}
                    design_id={this.state.active_saved_design_id}
                    is_saved_design={this.state.saved_design_share_modal}
                />
                <ThemeConfig clientName={ClientNames.designmaker}>
                    <Header
                        isLogin={this.props.user}
                        user={this.props.user&&this.props.user['inmagineUser']&&this.props.user['inmagineUser']['userDetails']?this.props.user['inmagineUser']['userDetails']['user']:this.props.user}
                        clientName={ClientNames.designmaker}
                        redirectPath='/designmaker/start'
                        onAction={({action}) => loginHandler(action)}
                    />
                </ThemeConfig>
                <div style={{width: '100%', paddingTop: 0}}>
                    <div style={{width: 232, float: 'left'}}>
                        <DashboardSidebar design_template_on_click={this.design_template_on_click}
                                          template_categories={this.state.template_categories}
                                          active_page={this.state.active_page}/>
                    </div>
                    <div style={{
                        width: '-webkit-fill-available',
                        marginLeft: 232,
                        paddingLeft: 40,
                        paddingRight: '0px',
                        'minHeight': '85vh',
                        'overflowY': 'auto'
                    }}
                    >
                        <Switch>
                            <Route path="/designmaker/start/search" render={(props) => (
                                <TemplateSearch 
                                    ThumbnailContextMenu={this.ThumbnailContextMenu} 
                                    templateOnClick={this.design_template_on_click} 
                                    {...props}
                                />
                            )}/>
                            <Route exact path="/designmaker/start" render={() => (
                                <this.DashboardHome
                                    page="home"
                                />
                            )}/>
                            <Route exact path="/designmaker/start/templates" render={() => (
                                <this.DashboardHome
                                    page="templates"
                                />
                            )}/>
                            {this.props.user && (<Route path="/designmaker/start/brand-kit" render={() => (<BrandKit/>)}/>)}
                            {this.props.user && (<Route path="/designmaker/start/design-orders" render={() => (<DesignOrders/>)}/>)}
                            <Route path="/designmaker/start/categories" render={() => (<Categories/>)}/>
                            {this.props.user && (<Route path="/designmaker/start/shared-designs" render={() => (<SharedDesigns/>)}/>)}
                            {this.props.user && (<Route key='root-folder-view' exact path="/designmaker/start/folders" render={() => (
                                <Folders saved_designs={this.state.saved_designs}/>)}/>)}
                            {this.props.user && (<Route key='folder-inner-view' path="/designmaker/start/folders/:folder_id/:role?"
                                                        render={() => (
                                                            <Folders saved_designs={this.state.saved_designs}/>)}/>)}
                            {this.props.user && (<Route path="/designmaker/start/all-designs" render={() => (
                                <DesignsPanel
                                    on_click={this.saved_design_on_click}
                                    resources={this.state.saved_designs}
                                    image_height={'200px'}
                                    noCache={true}
                                    refreshDesigns={this.refreshDesignsData}
                                />)}
                            />)}
                            <Route path="/designmaker/start/wizard" render={() => (<Wizard/>)}/>
                        </Switch>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = function (state) {
    return {
        user: state.user
    }
};

const mapDispatchToProps = dispatch => ({
    logout: () => {
        dispatch({type: 'none'});
    },
    open_login_modal: () => {
        dispatch(open_login_modal());
    },
    fetch_design_categories: () => dispatch(fetch_design_categories()),
    fetch_owned_designs: () => dispatch(fetch_owned_designs()),
    copy_into_saved_design: (id) => dispatch(copy_into_saved_design(id)),
    create_blank_design: (width, height, dimension_units) => dispatch(create_blank_design(width, height, dimension_units)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Dashboard))
